<template>
  <div class="contact">
    <Inbanner />
    <Content />
    <!-- <Form /> -->
  </div>
</template>
<script>
import Inbanner from './pages/Inbanner'
import Content from './pages/Content'
// import Form from './pages/Form'
export default{
    components:{
        Inbanner,Content,
        // Form
    }
}
</script>
<style>



</style>